// Generated from Func.g4 by ANTLR 4.5.1
// jshint ignore: start
/* eslint-disable */
var antlr4 = require('antlr4/index');
var FuncListener = require('./FuncListener').FuncListener;
var grammarFileName = 'Func.g4';

var serializedATN = [
  '\u0003\u0430\ud6d1\u8206\uad2d\u4417\uaef1\u8d80\uaadd',
  '\u0003\u001a\u0081\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004',
  '\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t\u0007',
  '\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0003\u0002',
  '\u0003\u0002\u0003\u0002\u0003\u0002\u0003\u0002\u0007\u0002\u001c\n',
  '\u0002\f\u0002\u000e\u0002\u001f\u000b\u0002\u0003\u0003\u0003\u0003',
  '\u0003\u0003\u0003\u0003\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004',
  '\u0003\u0004\u0003\u0004\u0005\u0004+\n\u0004\u0003\u0005\u0003\u0005',
  '\u0003\u0005\u0007\u00050\n\u0005\f\u0005\u000e\u00053\u000b\u0005\u0007',
  '\u00055\n\u0005\f\u0005\u000e\u00058\u000b\u0005\u0003\u0006\u0003\u0006',
  '\u0003\u0006\u0007\u0006=\n\u0006\f\u0006\u000e\u0006@\u000b\u0006\u0003',
  '\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0007\u0006F\n\u0006\f\u0006',
  '\u000e\u0006I\u000b\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0005',
  '\u0006N\n\u0006\u0003\u0006\u0003\u0006\u0007\u0006R\n\u0006\f\u0006',
  '\u000e\u0006U\u000b\u0006\u0005\u0006W\n\u0006\u0003\u0007\u0003\u0007',
  '\u0003\u0007\u0007\u0007\\\n\u0007\f\u0007\u000e\u0007_\u000b\u0007',
  '\u0003\b\u0003\b\u0003\t\u0003\t\u0005\te\n\t\u0003\n\u0005\nh\n\n\u0003',
  '\n\u0006\nk\n\n\r\n\u000e\nl\u0003\n\u0003\n\u0006\nq\n\n\r\n\u000e',
  '\nr\u0005\nu\n\n\u0003\u000b\u0005\u000bx\n\u000b\u0003\u000b\u0003',
  '\u000b\u0007\u000b|\n\u000b\f\u000b\u000e\u000b\u007f\u000b\u000b\u0003',
  '\u000b\u0002\u0002\f\u0002\u0004\u0006\b\n\f\u000e\u0010\u0012\u0014',
  '\u0002\u0005\u0003\u0002\u0003\u0006\u0004\u0002\u0014\u0014\u0016\u0017',
  '\u0005\u0002\u0014\u0014\u0016\u0017\u0019\u0019\u008b\u0002\u0016\u0003',
  '\u0002\u0002\u0002\u0004 \u0003\u0002\u0002\u0002\u0006*\u0003\u0002',
  '\u0002\u0002\b6\u0003\u0002\u0002\u0002\nV\u0003\u0002\u0002\u0002\f',
  'X\u0003\u0002\u0002\u0002\u000e`\u0003\u0002\u0002\u0002\u0010d\u0003',
  '\u0002\u0002\u0002\u0012g\u0003\u0002\u0002\u0002\u0014w\u0003\u0002',
  '\u0002\u0002\u0016\u001d\t\u0002\u0002\u0002\u0017\u0018\u0007\b\u0002',
  '\u0002\u0018\u0019\u0005\b\u0005\u0002\u0019\u001a\u0007\t\u0002\u0002',
  '\u001a\u001c\u0003\u0002\u0002\u0002\u001b\u0017\u0003\u0002\u0002\u0002',
  '\u001c\u001f\u0003\u0002\u0002\u0002\u001d\u001b\u0003\u0002\u0002\u0002',
  '\u001d\u001e\u0003\u0002\u0002\u0002\u001e\u0003\u0003\u0002\u0002\u0002',
  '\u001f\u001d\u0003\u0002\u0002\u0002 !\u0007\n\u0002\u0002!"\u0005',
  '\b\u0005\u0002"#\u0007\u000b\u0002\u0002#\u0005\u0003\u0002\u0002\u0002',
  '$+\u0005\n\u0006\u0002%+\u0005\u0014\u000b\u0002&+\u0005\u0010\t\u0002',
  "'+\u0005\f\u0007\u0002(+\u0005\u0004\u0003\u0002)+\u0005\u0002\u0002",
  '\u0002*$\u0003\u0002\u0002\u0002*%\u0003\u0002\u0002\u0002*&\u0003\u0002',
  "\u0002\u0002*'\u0003\u0002\u0002\u0002*(\u0003\u0002\u0002\u0002*)",
  '\u0003\u0002\u0002\u0002+\u0007\u0003\u0002\u0002\u0002,1\u0005\u0006',
  '\u0004\u0002-.\u0007\u0018\u0002\u0002.0\u0005\u0006\u0004\u0002/-\u0003',
  '\u0002\u0002\u000203\u0003\u0002\u0002\u00021/\u0003\u0002\u0002\u0002',
  '12\u0003\u0002\u0002\u000225\u0003\u0002\u0002\u000231\u0003\u0002\u0002',
  '\u00024,\u0003\u0002\u0002\u000258\u0003\u0002\u0002\u000264\u0003\u0002',
  '\u0002\u000267\u0003\u0002\u0002\u00027\t\u0003\u0002\u0002\u000286',
  '\u0003\u0002\u0002\u00029:\u0007\u0019\u0002\u0002:>\u0007\u0017\u0002',
  '\u0002;=\u0007\u0017\u0002\u0002<;\u0003\u0002\u0002\u0002=@\u0003\u0002',
  '\u0002\u0002><\u0003\u0002\u0002\u0002>?\u0003\u0002\u0002\u0002?W\u0003',
  '\u0002\u0002\u0002@>\u0003\u0002\u0002\u0002AB\u0007\n\u0002\u0002B',
  'C\u0007\u0019\u0002\u0002CG\u0007\u0017\u0002\u0002DF\u0007\u0017\u0002',
  '\u0002ED\u0003\u0002\u0002\u0002FI\u0003\u0002\u0002\u0002GE\u0003\u0002',
  '\u0002\u0002GH\u0003\u0002\u0002\u0002HJ\u0003\u0002\u0002\u0002IG\u0003',
  '\u0002\u0002\u0002JK\u0007\u000b\u0002\u0002KM\u0007\u0014\u0002\u0002',
  'LN\u0007\r\u0002\u0002ML\u0003\u0002\u0002\u0002MN\u0003\u0002\u0002',
  '\u0002NO\u0003\u0002\u0002\u0002OS\u0007\u0016\u0002\u0002PR\t\u0003',
  '\u0002\u0002QP\u0003\u0002\u0002\u0002RU\u0003\u0002\u0002\u0002SQ\u0003',
  '\u0002\u0002\u0002ST\u0003\u0002\u0002\u0002TW\u0003\u0002\u0002\u0002',
  'US\u0003\u0002\u0002\u0002V9\u0003\u0002\u0002\u0002VA\u0003\u0002\u0002',
  '\u0002W\u000b\u0003\u0002\u0002\u0002XY\u0007\u0015\u0002\u0002Y]\u0007',
  '\u0016\u0002\u0002Z\\\t\u0004\u0002\u0002[Z\u0003\u0002\u0002\u0002',
  '\\_\u0003\u0002\u0002\u0002][\u0003\u0002\u0002\u0002]^\u0003\u0002',
  '\u0002\u0002^\r\u0003\u0002\u0002\u0002_]\u0003\u0002\u0002\u0002`a',
  '\u0007\u0007\u0002\u0002a\u000f\u0003\u0002\u0002\u0002be\u0005\u0012',
  '\n\u0002ce\u0005\u000e\b\u0002db\u0003\u0002\u0002\u0002dc\u0003\u0002',
  '\u0002\u0002e\u0011\u0003\u0002\u0002\u0002fh\u0007\r\u0002\u0002gf',
  '\u0003\u0002\u0002\u0002gh\u0003\u0002\u0002\u0002hj\u0003\u0002\u0002',
  '\u0002ik\u0007\u0017\u0002\u0002ji\u0003\u0002\u0002\u0002kl\u0003\u0002',
  '\u0002\u0002lj\u0003\u0002\u0002\u0002lm\u0003\u0002\u0002\u0002mt\u0003',
  '\u0002\u0002\u0002np\u0007\u0014\u0002\u0002oq\u0007\u0017\u0002\u0002',
  'po\u0003\u0002\u0002\u0002qr\u0003\u0002\u0002\u0002rp\u0003\u0002\u0002',
  '\u0002rs\u0003\u0002\u0002\u0002su\u0003\u0002\u0002\u0002tn\u0003\u0002',
  '\u0002\u0002tu\u0003\u0002\u0002\u0002u\u0013\u0003\u0002\u0002\u0002',
  'vx\u0007\r\u0002\u0002wv\u0003\u0002\u0002\u0002wx\u0003\u0002\u0002',
  '\u0002xy\u0003\u0002\u0002\u0002y}\u0007\u0016\u0002\u0002z|\t\u0003',
  '\u0002\u0002{z\u0003\u0002\u0002\u0002|\u007f\u0003\u0002\u0002\u0002',
  '}{\u0003\u0002\u0002\u0002}~\u0003\u0002\u0002\u0002~\u0015\u0003\u0002',
  '\u0002\u0002\u007f}\u0003\u0002\u0002\u0002\u0013\u001d*16>GMSV]dgl',
  'rtw}',
].join('');

var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map(function (ds, index) {
  return new antlr4.dfa.DFA(ds, index);
});

var sharedContextCache = new antlr4.PredictionContextCache();

var literalNames = [
  'null',
  'null',
  "'@'",
  "'%'",
  'null',
  'null',
  "'('",
  "')'",
  "'['",
  "']'",
  "'+'",
  "'-'",
  "'*'",
  "'/'",
  "'>'",
  "'<'",
  "'='",
  'null',
  "'.'",
  "'^'",
  'null',
  'null',
  "','",
  "'&'",
];

var symbolicNames = [
  'null',
  'FNAME',
  'ATNAME',
  'PNAME',
  'ENAME',
  'STRING',
  'LPAREN',
  'RPAREN',
  'LBRACKET',
  'RBRACKET',
  'PLUS',
  'MINUS',
  'TIMES',
  'DIV',
  'GT',
  'LT',
  'EQ',
  'QM',
  'POINT',
  'CARET',
  'LETTER',
  'DIGIT',
  'COMMA',
  'AMP',
  'WS',
];

var ruleNames = [
  'func',
  'array',
  'atom',
  'params',
  'pathref',
  'contextref',
  'string',
  'literal',
  'number',
  'variable',
];

function FuncParser(input) {
  antlr4.Parser.call(this, input);
  this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
  this.ruleNames = ruleNames;
  this.literalNames = literalNames;
  this.symbolicNames = symbolicNames;
  return this;
}

FuncParser.prototype = Object.create(antlr4.Parser.prototype);
FuncParser.prototype.constructor = FuncParser;

Object.defineProperty(FuncParser.prototype, 'atn', {
  get: function () {
    return atn;
  },
});

FuncParser.EOF = antlr4.Token.EOF;
FuncParser.FNAME = 1;
FuncParser.ATNAME = 2;
FuncParser.PNAME = 3;
FuncParser.ENAME = 4;
FuncParser.STRING = 5;
FuncParser.LPAREN = 6;
FuncParser.RPAREN = 7;
FuncParser.LBRACKET = 8;
FuncParser.RBRACKET = 9;
FuncParser.PLUS = 10;
FuncParser.MINUS = 11;
FuncParser.TIMES = 12;
FuncParser.DIV = 13;
FuncParser.GT = 14;
FuncParser.LT = 15;
FuncParser.EQ = 16;
FuncParser.QM = 17;
FuncParser.POINT = 18;
FuncParser.CARET = 19;
FuncParser.LETTER = 20;
FuncParser.DIGIT = 21;
FuncParser.COMMA = 22;
FuncParser.AMP = 23;
FuncParser.WS = 24;

FuncParser.RULE_func = 0;
FuncParser.RULE_array = 1;
FuncParser.RULE_atom = 2;
FuncParser.RULE_params = 3;
FuncParser.RULE_pathref = 4;
FuncParser.RULE_contextref = 5;
FuncParser.RULE_string = 6;
FuncParser.RULE_literal = 7;
FuncParser.RULE_number = 8;
FuncParser.RULE_variable = 9;

function FuncContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FuncParser.RULE_func;
  return this;
}

FuncContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FuncContext.prototype.constructor = FuncContext;

FuncContext.prototype.FNAME = function () {
  return this.getToken(FuncParser.FNAME, 0);
};

FuncContext.prototype.ATNAME = function () {
  return this.getToken(FuncParser.ATNAME, 0);
};

FuncContext.prototype.PNAME = function () {
  return this.getToken(FuncParser.PNAME, 0);
};

FuncContext.prototype.ENAME = function () {
  return this.getToken(FuncParser.ENAME, 0);
};

FuncContext.prototype.LPAREN = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.LPAREN);
  } else {
    return this.getToken(FuncParser.LPAREN, i);
  }
};

FuncContext.prototype.params = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(ParamsContext);
  } else {
    return this.getTypedRuleContext(ParamsContext, i);
  }
};

FuncContext.prototype.RPAREN = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.RPAREN);
  } else {
    return this.getToken(FuncParser.RPAREN, i);
  }
};

FuncContext.prototype.enterRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.enterFunc(this);
  }
};

FuncContext.prototype.exitRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.exitFunc(this);
  }
};

FuncParser.FuncContext = FuncContext;

FuncParser.prototype.func = function () {
  var localctx = new FuncContext(this, this._ctx, this.state);
  this.enterRule(localctx, 0, FuncParser.RULE_func);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 20;
    _la = this._input.LA(1);
    if (
      !(
        (_la & ~0x1f) == 0 &&
        ((1 << _la) &
          ((1 << FuncParser.FNAME) |
            (1 << FuncParser.ATNAME) |
            (1 << FuncParser.PNAME) |
            (1 << FuncParser.ENAME))) !==
          0
      )
    ) {
      this._errHandler.recoverInline(this);
    } else {
      this.consume();
    }
    this.state = 27;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    while (_la === FuncParser.LPAREN) {
      this.state = 21;
      this.match(FuncParser.LPAREN);
      this.state = 22;
      this.params();
      this.state = 23;
      this.match(FuncParser.RPAREN);
      this.state = 29;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function ArrayContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FuncParser.RULE_array;
  return this;
}

ArrayContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ArrayContext.prototype.constructor = ArrayContext;

ArrayContext.prototype.LBRACKET = function () {
  return this.getToken(FuncParser.LBRACKET, 0);
};

ArrayContext.prototype.params = function () {
  return this.getTypedRuleContext(ParamsContext, 0);
};

ArrayContext.prototype.RBRACKET = function () {
  return this.getToken(FuncParser.RBRACKET, 0);
};

ArrayContext.prototype.enterRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.enterArray(this);
  }
};

ArrayContext.prototype.exitRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.exitArray(this);
  }
};

FuncParser.ArrayContext = ArrayContext;

FuncParser.prototype.array = function () {
  var localctx = new ArrayContext(this, this._ctx, this.state);
  this.enterRule(localctx, 2, FuncParser.RULE_array);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 30;
    this.match(FuncParser.LBRACKET);
    this.state = 31;
    this.params();
    this.state = 32;
    this.match(FuncParser.RBRACKET);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function AtomContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FuncParser.RULE_atom;
  return this;
}

AtomContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
AtomContext.prototype.constructor = AtomContext;

AtomContext.prototype.pathref = function () {
  return this.getTypedRuleContext(PathrefContext, 0);
};

AtomContext.prototype.variable = function () {
  return this.getTypedRuleContext(VariableContext, 0);
};

AtomContext.prototype.literal = function () {
  return this.getTypedRuleContext(LiteralContext, 0);
};

AtomContext.prototype.contextref = function () {
  return this.getTypedRuleContext(ContextrefContext, 0);
};

AtomContext.prototype.array = function () {
  return this.getTypedRuleContext(ArrayContext, 0);
};

AtomContext.prototype.func = function () {
  return this.getTypedRuleContext(FuncContext, 0);
};

AtomContext.prototype.enterRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.enterAtom(this);
  }
};

AtomContext.prototype.exitRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.exitAtom(this);
  }
};

FuncParser.AtomContext = AtomContext;

FuncParser.prototype.atom = function () {
  var localctx = new AtomContext(this, this._ctx, this.state);
  this.enterRule(localctx, 4, FuncParser.RULE_atom);
  try {
    this.state = 40;
    var la_ = this._interp.adaptivePredict(this._input, 1, this._ctx);
    switch (la_) {
      case 1:
        this.enterOuterAlt(localctx, 1);
        this.state = 34;
        this.pathref();
        break;

      case 2:
        this.enterOuterAlt(localctx, 2);
        this.state = 35;
        this.variable();
        break;

      case 3:
        this.enterOuterAlt(localctx, 3);
        this.state = 36;
        this.literal();
        break;

      case 4:
        this.enterOuterAlt(localctx, 4);
        this.state = 37;
        this.contextref();
        break;

      case 5:
        this.enterOuterAlt(localctx, 5);
        this.state = 38;
        this.array();
        break;

      case 6:
        this.enterOuterAlt(localctx, 6);
        this.state = 39;
        this.func();
        break;
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function ParamsContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FuncParser.RULE_params;
  return this;
}

ParamsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ParamsContext.prototype.constructor = ParamsContext;

ParamsContext.prototype.atom = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(AtomContext);
  } else {
    return this.getTypedRuleContext(AtomContext, i);
  }
};

ParamsContext.prototype.COMMA = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.COMMA);
  } else {
    return this.getToken(FuncParser.COMMA, i);
  }
};

ParamsContext.prototype.enterRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.enterParams(this);
  }
};

ParamsContext.prototype.exitRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.exitParams(this);
  }
};

FuncParser.ParamsContext = ParamsContext;

FuncParser.prototype.params = function () {
  var localctx = new ParamsContext(this, this._ctx, this.state);
  this.enterRule(localctx, 6, FuncParser.RULE_params);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 52;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    while (
      (_la & ~0x1f) == 0 &&
      ((1 << _la) &
        ((1 << FuncParser.FNAME) |
          (1 << FuncParser.ATNAME) |
          (1 << FuncParser.PNAME) |
          (1 << FuncParser.ENAME) |
          (1 << FuncParser.STRING) |
          (1 << FuncParser.LBRACKET) |
          (1 << FuncParser.MINUS) |
          (1 << FuncParser.CARET) |
          (1 << FuncParser.LETTER) |
          (1 << FuncParser.DIGIT) |
          (1 << FuncParser.AMP))) !==
        0
    ) {
      this.state = 42;
      this.atom();
      this.state = 47;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
      while (_la === FuncParser.COMMA) {
        this.state = 43;
        this.match(FuncParser.COMMA);
        this.state = 44;
        this.atom();
        this.state = 49;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
      }
      this.state = 54;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function PathrefContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FuncParser.RULE_pathref;
  return this;
}

PathrefContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PathrefContext.prototype.constructor = PathrefContext;

PathrefContext.prototype.AMP = function () {
  return this.getToken(FuncParser.AMP, 0);
};

PathrefContext.prototype.DIGIT = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.DIGIT);
  } else {
    return this.getToken(FuncParser.DIGIT, i);
  }
};

PathrefContext.prototype.LBRACKET = function () {
  return this.getToken(FuncParser.LBRACKET, 0);
};

PathrefContext.prototype.RBRACKET = function () {
  return this.getToken(FuncParser.RBRACKET, 0);
};

PathrefContext.prototype.POINT = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.POINT);
  } else {
    return this.getToken(FuncParser.POINT, i);
  }
};

PathrefContext.prototype.LETTER = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.LETTER);
  } else {
    return this.getToken(FuncParser.LETTER, i);
  }
};

PathrefContext.prototype.MINUS = function () {
  return this.getToken(FuncParser.MINUS, 0);
};

PathrefContext.prototype.enterRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.enterPathref(this);
  }
};

PathrefContext.prototype.exitRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.exitPathref(this);
  }
};

FuncParser.PathrefContext = PathrefContext;

FuncParser.prototype.pathref = function () {
  var localctx = new PathrefContext(this, this._ctx, this.state);
  this.enterRule(localctx, 8, FuncParser.RULE_pathref);
  var _la = 0; // Token type
  try {
    this.state = 84;
    switch (this._input.LA(1)) {
      case FuncParser.AMP:
        this.enterOuterAlt(localctx, 1);
        this.state = 55;
        this.match(FuncParser.AMP);
        this.state = 56;
        this.match(FuncParser.DIGIT);
        this.state = 60;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input, 4, this._ctx);
        while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            this.state = 57;
            this.match(FuncParser.DIGIT);
          }
          this.state = 62;
          this._errHandler.sync(this);
          _alt = this._interp.adaptivePredict(this._input, 4, this._ctx);
        }

        break;
      case FuncParser.LBRACKET:
        this.enterOuterAlt(localctx, 2);
        this.state = 63;
        this.match(FuncParser.LBRACKET);
        this.state = 64;
        this.match(FuncParser.AMP);
        this.state = 65;
        this.match(FuncParser.DIGIT);
        this.state = 69;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while (_la === FuncParser.DIGIT) {
          this.state = 66;
          this.match(FuncParser.DIGIT);
          this.state = 71;
          this._errHandler.sync(this);
          _la = this._input.LA(1);
        }
        this.state = 72;
        this.match(FuncParser.RBRACKET);

        this.state = 73;
        this.match(FuncParser.POINT);
        this.state = 75;
        _la = this._input.LA(1);
        if (_la === FuncParser.MINUS) {
          this.state = 74;
          this.match(FuncParser.MINUS);
        }

        this.state = 77;
        this.match(FuncParser.LETTER);
        this.state = 81;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input, 7, this._ctx);
        while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            this.state = 78;
            _la = this._input.LA(1);
            if (
              !(
                (_la & ~0x1f) == 0 &&
                ((1 << _la) &
                  ((1 << FuncParser.POINT) |
                    (1 << FuncParser.LETTER) |
                    (1 << FuncParser.DIGIT))) !==
                  0
              )
            ) {
              this._errHandler.recoverInline(this);
            } else {
              this.consume();
            }
          }
          this.state = 83;
          this._errHandler.sync(this);
          _alt = this._interp.adaptivePredict(this._input, 7, this._ctx);
        }

        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function ContextrefContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FuncParser.RULE_contextref;
  return this;
}

ContextrefContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ContextrefContext.prototype.constructor = ContextrefContext;

ContextrefContext.prototype.CARET = function () {
  return this.getToken(FuncParser.CARET, 0);
};

ContextrefContext.prototype.LETTER = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.LETTER);
  } else {
    return this.getToken(FuncParser.LETTER, i);
  }
};

ContextrefContext.prototype.DIGIT = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.DIGIT);
  } else {
    return this.getToken(FuncParser.DIGIT, i);
  }
};

ContextrefContext.prototype.POINT = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.POINT);
  } else {
    return this.getToken(FuncParser.POINT, i);
  }
};

ContextrefContext.prototype.AMP = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.AMP);
  } else {
    return this.getToken(FuncParser.AMP, i);
  }
};

ContextrefContext.prototype.enterRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.enterContextref(this);
  }
};

ContextrefContext.prototype.exitRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.exitContextref(this);
  }
};

FuncParser.ContextrefContext = ContextrefContext;

FuncParser.prototype.contextref = function () {
  var localctx = new ContextrefContext(this, this._ctx, this.state);
  this.enterRule(localctx, 10, FuncParser.RULE_contextref);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 86;
    this.match(FuncParser.CARET);
    this.state = 87;
    this.match(FuncParser.LETTER);
    this.state = 91;
    this._errHandler.sync(this);
    var _alt = this._interp.adaptivePredict(this._input, 9, this._ctx);
    while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER) {
      if (_alt === 1) {
        this.state = 88;
        _la = this._input.LA(1);
        if (
          !(
            (_la & ~0x1f) == 0 &&
            ((1 << _la) &
              ((1 << FuncParser.POINT) |
                (1 << FuncParser.LETTER) |
                (1 << FuncParser.DIGIT) |
                (1 << FuncParser.AMP))) !==
              0
          )
        ) {
          this._errHandler.recoverInline(this);
        } else {
          this.consume();
        }
      }
      this.state = 93;
      this._errHandler.sync(this);
      _alt = this._interp.adaptivePredict(this._input, 9, this._ctx);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function StringContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FuncParser.RULE_string;
  return this;
}

StringContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
StringContext.prototype.constructor = StringContext;

StringContext.prototype.STRING = function () {
  return this.getToken(FuncParser.STRING, 0);
};

StringContext.prototype.enterRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.enterString(this);
  }
};

StringContext.prototype.exitRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.exitString(this);
  }
};

FuncParser.StringContext = StringContext;

FuncParser.prototype.string = function () {
  var localctx = new StringContext(this, this._ctx, this.state);
  this.enterRule(localctx, 12, FuncParser.RULE_string);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 94;
    this.match(FuncParser.STRING);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function LiteralContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FuncParser.RULE_literal;
  return this;
}

LiteralContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LiteralContext.prototype.constructor = LiteralContext;

LiteralContext.prototype.number = function () {
  return this.getTypedRuleContext(NumberContext, 0);
};

LiteralContext.prototype.string = function () {
  return this.getTypedRuleContext(StringContext, 0);
};

LiteralContext.prototype.enterRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.enterLiteral(this);
  }
};

LiteralContext.prototype.exitRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.exitLiteral(this);
  }
};

FuncParser.LiteralContext = LiteralContext;

FuncParser.prototype.literal = function () {
  var localctx = new LiteralContext(this, this._ctx, this.state);
  this.enterRule(localctx, 14, FuncParser.RULE_literal);
  try {
    this.state = 98;
    switch (this._input.LA(1)) {
      case FuncParser.MINUS:
      case FuncParser.DIGIT:
        this.enterOuterAlt(localctx, 1);
        this.state = 96;
        this.number();
        break;
      case FuncParser.STRING:
        this.enterOuterAlt(localctx, 2);
        this.state = 97;
        this.string();
        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function NumberContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FuncParser.RULE_number;
  return this;
}

NumberContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
NumberContext.prototype.constructor = NumberContext;

NumberContext.prototype.MINUS = function () {
  return this.getToken(FuncParser.MINUS, 0);
};

NumberContext.prototype.DIGIT = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.DIGIT);
  } else {
    return this.getToken(FuncParser.DIGIT, i);
  }
};

NumberContext.prototype.POINT = function () {
  return this.getToken(FuncParser.POINT, 0);
};

NumberContext.prototype.enterRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.enterNumber(this);
  }
};

NumberContext.prototype.exitRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.exitNumber(this);
  }
};

FuncParser.NumberContext = NumberContext;

FuncParser.prototype.number = function () {
  var localctx = new NumberContext(this, this._ctx, this.state);
  this.enterRule(localctx, 16, FuncParser.RULE_number);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 101;
    _la = this._input.LA(1);
    if (_la === FuncParser.MINUS) {
      this.state = 100;
      this.match(FuncParser.MINUS);
    }

    this.state = 104;
    this._errHandler.sync(this);
    var _alt = 1;
    do {
      switch (_alt) {
        case 1:
          this.state = 103;
          this.match(FuncParser.DIGIT);
          break;
        default:
          throw new antlr4.error.NoViableAltException(this);
      }
      this.state = 106;
      this._errHandler.sync(this);
      _alt = this._interp.adaptivePredict(this._input, 12, this._ctx);
    } while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER);
    this.state = 114;
    _la = this._input.LA(1);
    if (_la === FuncParser.POINT) {
      this.state = 108;
      this.match(FuncParser.POINT);
      this.state = 110;
      this._errHandler.sync(this);
      var _alt = 1;
      do {
        switch (_alt) {
          case 1:
            this.state = 109;
            this.match(FuncParser.DIGIT);
            break;
          default:
            throw new antlr4.error.NoViableAltException(this);
        }
        this.state = 112;
        this._errHandler.sync(this);
        _alt = this._interp.adaptivePredict(this._input, 13, this._ctx);
      } while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function VariableContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FuncParser.RULE_variable;
  return this;
}

VariableContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
VariableContext.prototype.constructor = VariableContext;

VariableContext.prototype.LETTER = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.LETTER);
  } else {
    return this.getToken(FuncParser.LETTER, i);
  }
};

VariableContext.prototype.MINUS = function () {
  return this.getToken(FuncParser.MINUS, 0);
};

VariableContext.prototype.DIGIT = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.DIGIT);
  } else {
    return this.getToken(FuncParser.DIGIT, i);
  }
};

VariableContext.prototype.POINT = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FuncParser.POINT);
  } else {
    return this.getToken(FuncParser.POINT, i);
  }
};

VariableContext.prototype.enterRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.enterVariable(this);
  }
};

VariableContext.prototype.exitRule = function (listener) {
  if (listener instanceof FuncListener) {
    listener.exitVariable(this);
  }
};

FuncParser.VariableContext = VariableContext;

FuncParser.prototype.variable = function () {
  var localctx = new VariableContext(this, this._ctx, this.state);
  this.enterRule(localctx, 18, FuncParser.RULE_variable);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 117;
    _la = this._input.LA(1);
    if (_la === FuncParser.MINUS) {
      this.state = 116;
      this.match(FuncParser.MINUS);
    }

    this.state = 119;
    this.match(FuncParser.LETTER);
    this.state = 123;
    this._errHandler.sync(this);
    var _alt = this._interp.adaptivePredict(this._input, 16, this._ctx);
    while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER) {
      if (_alt === 1) {
        this.state = 120;
        _la = this._input.LA(1);
        if (
          !(
            (_la & ~0x1f) == 0 &&
            ((1 << _la) &
              ((1 << FuncParser.POINT) | (1 << FuncParser.LETTER) | (1 << FuncParser.DIGIT))) !==
              0
          )
        ) {
          this._errHandler.recoverInline(this);
        } else {
          this.consume();
        }
      }
      this.state = 125;
      this._errHandler.sync(this);
      _alt = this._interp.adaptivePredict(this._input, 16, this._ctx);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

exports.FuncParser = FuncParser;
